// button styles
$dc-ui-btn-animation-duration: 0.35s;
$dc-ui-btn-focus-color: $color-focus;
$dc-ui-btn-focus-color-inset: $color-white;

// primary button
$dc-ui-btn-primary-bg: $color-red-brand-01;
$dc-ui-btn-primary-bg-hover: $color-red-brand-02;
$dc-ui-btn-primary-bg-active: $color-red-brand-03;
$dc-ui-btn-primary-color: $color-white;
$dc-ui-btn-primary-disabled-bg: $color-grey-02;
$dc-ui-btn-primary-disabled-color: $color-grey-03;

// secondary button
$dc-ui-btn-secondary-bg: $color-turquoise-01;
$dc-ui-btn-secondary-bg-hover: $color-turquoise-02;
$dc-ui-btn-secondary-bg-active: $color-turquoise-03;
$dc-ui-btn-secondary-color: $color-turquoise-06;
$dc-ui-btn-secondary-disabled-bg: $color-grey-02;
$dc-ui-btn-secondary-disabled-color: $color-grey-03;

// tertiary button
$dc-ui-btn-tertiary-bg: $color-grey-06;
$dc-ui-btn-tertiary-bg-hover: $color-grey-07;
$dc-ui-btn-tertiary-bg-active: $color-grey-08;
$dc-ui-btn-tertiary-color: $color-white;
$dc-ui-btn-tertiary-color-hover: $color-grey-10;
$dc-ui-btn-tertiary-disabled-bg: $color-grey-02;
$dc-ui-btn-tertiary-disabled-color: $color-grey-03;

// light button
$dc-ui-btn-light-bg: $color-grey-03;
$dc-ui-btn-light-bg-hover: $color-grey-04;
$dc-ui-btn-light-bg-active: $color-grey-05;
$dc-ui-btn-light-color: $color-dark-blue-02;
$dc-ui-btn-light-color-hover: $color-black;
$dc-ui-btn-light-disabled-bg: $color-grey-02;
$dc-ui-btn-light-disabled-color: $color-grey-03;

// link button
$dc-ui-btn-link-bg: transparent;
$dc-ui-btn-link-bg-hover: $color-grey-01;
$dc-ui-btn-link-bg-active: $color-grey-02;
$dc-ui-btn-link-color: $color-grey-06;
$dc-ui-btn-link-color-hover: $color-grey-10;
$dc-ui-btn-link-disabled-bg: transparent;
$dc-ui-btn-link-disabled-color: $color-grey-03;

@media screen and (prefers-reduced-motion: reduce) {
  $dc-ui-btn-animation-duration: 0s;
}

:host {
  display: inline-block;
  width: auto;
  cursor: pointer;
}

.dc-ui-btn {
  align-content: center;
  align-items: center;
  border: none;
  cursor: inherit;
  display: inline-flex;
  gap: 7px;
  justify-content: center;
  outline: 0;
  padding: 0;
  position: relative;
  text-transform: uppercase;
  user-select: none;
  vertical-align: middle;
  white-space: nowrap;
  width: 100%;

  background-size: 300% 300%;
  background-position: 0 0;
  animation: animation-out 350ms forwards;

  & > span {
    font-family: 'Bosch sans';
  }

  &.disabled,
  &[disabled] {
    cursor: not-allowed;
  }

  &:focus-visible:not(.disabled):not([disabled]) {
    &:before {
      content: '';
      position: absolute;
      inset: 0;
      border: 2px solid $dc-ui-btn-focus-color;
      z-index: 3;
    }

    &:after {
      content: '';
      position: absolute;
      inset: 2px;
      border: 1px solid $dc-ui-btn-focus-color-inset;
      z-index: 3;
    }
  }

  &--align-left {
    justify-content: flex-start;
  }

  &--align-right {
    justify-content: flex-end;
  }

  &--primary {
    background-color: $dc-ui-btn-primary-bg;
    color: $dc-ui-btn-primary-color;

    background-image: linear-gradient(
      -4deg,
      transparent 33%,
      $dc-ui-btn-primary-bg-hover 34%,
      $dc-ui-btn-primary-bg-hover 66%,
      transparent 67%
    );

    &:active:not(.disabled):not([disabled]) {
      background-image: none;
      background-color: $dc-ui-btn-primary-bg-active;
    }

    &.disabled,
    &[disabled] {
      background-color: $dc-ui-btn-primary-disabled-bg;
      color: $dc-ui-btn-primary-disabled-color;
    }
  }

  &--secondary {
    background-color: $dc-ui-btn-secondary-bg;
    color: $dc-ui-btn-secondary-color;

    background-image: linear-gradient(
      -4deg,
      transparent 33%,
      $dc-ui-btn-secondary-bg-hover 34%,
      $dc-ui-btn-secondary-bg-hover 66%,
      transparent 67%
    );

    &:active:not(.disabled):not([disabled]) {
      background-image: none;
      background-color: $dc-ui-btn-secondary-bg-active;
    }

    &.disabled,
    &[disabled] {
      background-color: $dc-ui-btn-secondary-disabled-bg;
      color: $dc-ui-btn-secondary-disabled-color;
    }
  }

  &--tertiary {
    background-color: $dc-ui-btn-tertiary-bg;
    color: $dc-ui-btn-tertiary-color;

    background-image: linear-gradient(
      -4deg,
      transparent 33%,
      $dc-ui-btn-tertiary-bg-hover 34%,
      $dc-ui-btn-tertiary-bg-hover 66%,
      transparent 67%
    );

    &:active:not(.disabled):not([disabled]) {
      background-image: none;
      background-color: $dc-ui-btn-tertiary-bg-active;
    }

    &.disabled,
    &[disabled] {
      background-color: $dc-ui-btn-tertiary-disabled-bg;
      color: $dc-ui-btn-tertiary-disabled-color;
    }
  }

  &--light {
    background-color: $dc-ui-btn-light-bg;
    color: $dc-ui-btn-light-color;

    &:hover,
    &:focus,
    &:active {
      color: $dc-ui-btn-light-color-hover;
    }

    background-image: linear-gradient(
      -4deg,
      transparent 33%,
      $dc-ui-btn-light-bg-hover 34%,
      $dc-ui-btn-light-bg-hover 66%,
      transparent 67%
    );

    &:active:not(.disabled):not([disabled]) {
      background-image: none;
      background-color: $dc-ui-btn-light-bg-active;
    }

    &.disabled,
    &[disabled] {
      background-color: $dc-ui-btn-light-disabled-bg;
      color: $dc-ui-btn-light-disabled-color;
    }
  }

  &--link {
    background-color: $dc-ui-btn-link-bg;
    color: $dc-ui-btn-link-color;

    &:hover,
    &:focus,
    &:active {
      color: $dc-ui-btn-link-color-hover;
    }

    background-image: linear-gradient(
      -4deg,
      transparent 33%,
      $dc-ui-btn-link-bg-hover 34%,
      $dc-ui-btn-link-bg-hover 66%,
      transparent 67%
    );

    &:active:not(.disabled):not([disabled]) {
      background-image: none;
      background-color: $dc-ui-btn-link-bg-active;
    }

    &.disabled,
    &[disabled] {
      background-color: $dc-ui-btn-link-disabled-bg;
      color: $dc-ui-btn-link-disabled-color;
    }
  }

  &--small {
    height: 32px;
    padding: 0 15px;
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 900;

    &.dc-ui-btn--icon:not(.dc-ui-btn--hide-label) {
      padding: 0 15px 0 16px;
    }

    &.dc-ui-btn--hide-label {
      padding: 0 6px;
    }
  }

  &--normal {
    height: 48px;
    padding: 0 15px;
    font-size: 1rem;
    line-height: 1.25rem;
    font-weight: 900;

    &.dc-ui-btn--icon:not(.dc-ui-btn--hide-label) {
      padding: 0 15px 0 16px;
    }

    &.dc-ui-btn--hide-label {
      padding: 0 12px;
    }
  }

  &--large {
    height: 54px;
    padding: 0 15px;
    font-size: 1.25rem;
    line-height: 1.375rem;
    font-weight: 900;

    &.dc-ui-btn--icon:not(.dc-ui-btn--hide-label) {
      padding: 0 15px 0 16px;
    }

    &.dc-ui-btn--hide-label {
      padding: 0 11px;
    }
  }

  &--hide-label {
    gap: 0;

    & > span {
      display: block;
      width: 1px;
      text-size-adjust: none;
      height: 1px;
      margin: 0px 0px 0px -1px;
      overflow: hidden;
    }
  }

  &:hover:not(.disabled):not([disabled]) {
    animation: animation-in 350ms forwards;
  }
}

@keyframes animation-out {
  from {
    z-index: inherit;
    background-position: 50% 50%;
  }
  to {
    background-position: 100% 100%;
  }
}

@keyframes animation-in {
  from {
    z-index: inherit;
    background-position: 0 0;
  }
  to {
    z-index: inherit;
    background-position: 50% 50%;
  }
}
